import { Jose, JoseJWE } from 'jose-jwe'
import jwkToPem from 'jwk-to-pem'
import rasha from 'rasha'

const encrypt = {

  /**
   * encrypt card object using JWE
   * @param userDetails
   * @param encParams
   * @returns {Promise<string>}
   */
  async encryptCard (userDetails, encParams) {
    try {
      // encrypt card before sending
      let webKey = ''
      webKey = encParams.keys.find((item) => item.kid.toLowerCase() === encParams.encKeyId.toLowerCase())
      const publicKeyPem = jwkToPem(webKey)
      const message = JSON.stringify(userDetails)

      const publicKeyJwk = await rasha.import({ pem: publicKeyPem })
      const cryptographer = new Jose.WebCryptographer()
      cryptographer.setKeyEncryptionAlgorithm(encParams.encAlgo)
      cryptographer.setContentEncryptionAlgorithm(encParams.encContentAlgo)
      const key = Jose.Utils.importRsaPublicKey(publicKeyJwk, encParams.encAlgo)
      const encrypter = new JoseJWE.Encrypter(cryptographer, key)
      encrypter.addHeader('kid', webKey.kid)
      return await encrypter.encrypt(message)
    } catch (error) {
      console.error('error :' + error.message)
    }
  }

}

export default encrypt
